//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"CanChangeLockStatus",0,0],[0,"Cell",0,"DisplayableObject",0],[0,"ContentType",0,0],[0,"EditableText",1,0],[0,"Label",1,0],[0,"Lock",1,0],[0,"Text",0,0]],[[["lockStatus","contentType","value","label","canChangeLockStatus"],"EditCell",{},5,1],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.TitleBlockCellBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TitleBlockCellBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;